
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { AvatarDropdown, AvatarName, Footer } from '@/components';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import '@ant-design/v5-patch-for-react-19';
import { ReactComponent as UserAttr } from '@/icons/abb_user-in-circle_16.svg'
import { getApiPesAccessTokenCurrentLoginUserInfo } from '@/services/pes/accessToken'
import Icon from '@ant-design/icons';
import { Button } from 'antd'
import { UnorderedListOutlined } from '@ant-design/icons'
import { GetMenuData } from '@/models/menuData'
import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}
const isDev = process.env.NODE_ENV === 'development';
const loginRedirect = '/login/redirect';
/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.UserInfoDto;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.UserInfoDto | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await getApiPesAccessTokenCurrentLoginUserInfo();
      if (!msg) {
        history.push(loginRedirect);
      }
      return msg;
    } catch (_error) {
      history.push(loginRedirect);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (![loginRedirect, OIDC_REDIRECT_URL].includes(location.pathname)) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    fixedHeader: true,
    actionsRender: () => [<Button key={'check'}
      icon={<UnorderedListOutlined />}
      color='default'
      variant='text'
      onClick={() => {
        history.push('/So/todolist');
      }}>我的任务</Button>],
    avatarProps: {
      src: <Icon component={UserAttr} />,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    menu: {
      request: async () => GetMenuData()
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login，但放行 OIDC 回调路径，确保回调页能执行
      if (
        !initialState?.currentUser &&
        ![loginRedirect, OIDC_REDIRECT_URL].includes(location.pathname)
      ) {
        history.push(loginRedirect);
      }
    },
    links: [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...errorConfig,
};

